import { Inject, Injectable } from "@angular/core";
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from "@azure/msal-angular";
import { AccountInfo, AuthenticationResult, InteractionStatus, PopupRequest } from "@azure/msal-browser";
import { BehaviorSubject, filter } from "rxjs";
import { SessionService } from "./session.service";
import { ApiService } from "./api.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  userSettings$ = new BehaviorSubject<any>(null); // <-- User settings stored here
  public loginDisplay: boolean = false;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalBroadcastService: MsalBroadcastService,
    private msalService: MsalService,
    private sessionService: SessionService,
    private apiService: ApiService,
    private router: Router,
  ) {
    this.msalService.handleRedirectObservable().subscribe();
    this.msalBroadcastService.inProgress$
      .pipe(filter(status => status === InteractionStatus.None))
      .subscribe(() => {
        console.log('MSAL INPROGRESS');
        const account = this.msalService.instance.getActiveAccount();
        console.log('ACTIVE ACCOUNT', account);
        if (account) {
          this.loadUserSettings(account);
        }
      });
  }

  loadUserSettings(account: AccountInfo) {
    if (account && !this.sessionService.hasFetrapiSession()) {
      const memberId: string = account.localAccountId;
      this.apiService.getMember(memberId).subscribe({
        next: (response) => {
          this.sessionService.setFetrapiSession(JSON.stringify(response));
          this.router.navigateByUrl('/');
        },
        error: (error: any) => { 
          console.log('error on getting fetrapiSession: ', error);
        }
      })
    }
  }

  public getAccount(): AccountInfo | undefined {
    return undefined;
  }

  loginPopup() {
    console.log('LOGIN POPUP, authrequest: ', this.msalGuardConfig.authRequest);
    if (this.msalGuardConfig.authRequest) {
      this.msalService
        .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe({
          next: (response: AuthenticationResult) => {
            console.log('LOGIN: RESPONSE ACCOUNT', response.account);
            this.msalService.instance.setActiveAccount(response.account);
            if (response.account) {
              this.loadUserSettings(response.account);
            }
            // this.sessionService.setFetrapiSession(JSON.stringify(response.account));
            // this.router.navigateByUrl('/');
          },
          error: (error: any) => console.log('error on loginPopup', error)
        });
    } else {
      this.msalService
        .loginPopup()
        .subscribe((response: AuthenticationResult) => {
          this.msalService.instance.setActiveAccount(response.account);
          if (response.account) {
            this.loadUserSettings(response.account);
          }
          // this.sessionService.setFetrapiSession(JSON.stringify(response.account));
          // this.router.navigateByUrl('/');
        });
    }
  }

  logOut(popup?: boolean) {
    console.log('LOGOUT');
    if (popup) {
      this.msalService.logoutPopup({
        mainWindowRedirectUri: '/',
      });
    } else {
      this.msalService.logoutRedirect();
    }
  }

}